module.exports = __webpack_public_path__ + "media/images/newsletter-svg-91263fa6abc5555aa7f94d6178b56b03.svg";